<template>
  <section class="section full-height">
    <router-view></router-view>
  </section>
</template>

<script>
export default {
  name: 'Users',
  components: {},
  data() {
    return {
      clients: [],
      isLoadingClients: false
    }
  },
  mounted() {
    this.$store.commit('layout/SUB_PAGE', {
      stack: ['Admin', 'Users'],
      title: 'Users'
    })
  }
}
</script>

<style scoped></style>
